import { Mail } from "lucide-react";
import { Logo } from "./Navbar";
import { scrollToId } from "@/lib/scroll";

const COLUMNS = [
  {
    title: "Herramientas",
    links: [
      { label: "Rentabilidad inmobiliaria", href: "#herramientas", testid: "footer-link-rentabilidad" },
      { label: "Cash flow", href: "#herramientas", testid: "footer-link-cash-flow" },
      { label: "Hipoteca", href: "#herramientas", testid: "footer-link-hipoteca" },
      { label: "ROI", href: "#herramientas", testid: "footer-link-roi" },
      { label: "Comprar vs alquilar", href: "#herramientas", testid: "footer-link-comprar-vs-alquilar" },
    ],
  },
  {
    title: "Guías",
    links: [
      { label: "Guía del inversor primerizo", href: "/guia-inversion-inmobiliaria", testid: "footer-link-guia-inversor" },
      { label: "Gastos de compraventa", href: "#guias", testid: "footer-link-gastos" },
      { label: "Fiscalidad del alquiler", href: "#guias", testid: "footer-link-fiscalidad" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Aviso legal", href: "/aviso-legal", testid: "footer-link-aviso-legal" },
      { label: "Política de privacidad", href: "/politica-privacidad", testid: "footer-link-privacidad" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-slate-200 bg-white">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
            Analiza la rentabilidad, cash flow y riesgo de cualquier inversión inmobiliaria.
          </p>
          <a
            data-testid="footer-link-contacto"
            href="mailto:hola@pisoscore.es"
            className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-slate-700 transition-colors hover:text-emerald-600"
          >
            <Mail className="h-4 w-4 text-emerald-500" /> hola@pisoscore.es
          </a>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <p className="mb-4 text-xs font-semibold uppercase tracking-wider text-slate-400">{col.title}</p>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.testid}>
                  <a
                    data-testid={l.testid}
                    href={l.href}
                    onClick={
                      l.href.startsWith("/")
                        ? undefined
                        : (e) => {
                            e.preventDefault();
                            window.location.pathname !== "/"
                              ? (window.location.href = `/${l.href}`)
                              : scrollToId(l.href);
                          }
                    }
                    className="text-sm text-slate-600 transition-colors hover:text-emerald-600"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-slate-100 pt-7 sm:flex-row">
        <p className="text-xs text-slate-400">
          © 2026 PisoScore Technologies S.L. Todos los derechos reservados. Tecnología financiera inmobiliaria.
        </p>
        <p className="text-xs text-slate-400">Hecho con datos en España</p>
      </div>
    </div>
  </footer>
);
